<div class="codalt-container">
    <div class="corner">
        <mat-form-field appearance="fill">
            <mat-label>Filter dashboard</mat-label>
            <mat-select (ngModelChange)="filter.set($event); updateFilter($event)" [ngModel]="filter()" multiple placeholder="Filter dashboard">
                <mat-optgroup label="Gegevens">
                    <mat-option value="revenue">Omzet per status</mat-option>
                    <mat-option value="count">Aantallen</mat-option>
                    <mat-option value="surface">Oppervlakte / lengte</mat-option>
                    <mat-option value="price">Omzet</mat-option>
                    <mat-option value="emptyCas">Klantgebieden zonder werk</mat-option>
                    <mat-option value="materialSpecific">Per materiaal</mat-option>
                </mat-optgroup>
                <mat-optgroup label="Materialen">
                    @for (material of allMaterials(); track material) {
                        <mat-option [disabled]="!showMaterialSpecific()" [value]="material.id">
                            {{material.name}}
                        </mat-option>
                    }
                </mat-optgroup>
            </mat-select>
        </mat-form-field>

        <a class="back" routerLink="/management">
            <i class="fa fa-arrow-circle-left"></i> Terug
        </a>
    </div>
    <div class="areas sticky-left">
        <div class="space"></div>
        @for (ca of customerAreas(); track ca) {
            <div [class.show-inspections]="showInspectionsFor() === ca" class="customer-area curpoint">
                <div (click)="showInspectionsFor.set(ca)" (mouseenter)="mousen(ca.name)" [class.highlight]="highlightCa() === ca.name" class="area">
                    {{ca.name}}
                </div>
                @if (showInspectionsFor() === ca) {
                    @for (inspection of ca.inspections; track inspection; let last = $last) {
                        <div (mouseenter)="mousen(inspection.id)" [class.highlight]="highlightCa() === inspection.id" [class.last]="last" class="area inspection ps-3">
                            {{inspection.name}}
                        </div>
                    }
                }
            </div>
        }
        <div (mouseenter)="mousen('total')"
             [class.highlight]="highlightCa() === 'total'">
            Totaal
        </div>
    </div>
    @if (materialPrices() && decorationPrices() && extraCostsPrices() && pushpinParts()) {
        <div class="cols col-right">
            @if (showRevenue()) {
                <div class="type statuses">
                    <div class="sticky-top">
                        <div class="name">Status</div>
                        <div class="cols">
                            @for (status of statuses(); track status) {
                                <div
                                    class="status">
                                    <div
                                        [class.txtwhite]="[StatusId.Afgekeurd,StatusId.Concept].indexOf(status.id) !== -1"
                                        [style.background-color]="'#' + status.color"
                                        class="text">
                                        {{status.name}}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    @for (ca of customerAreas(); track ca) {
                        <div [class.show-inspections]="showInspectionsFor() === ca" class="customer-area">
                            <div (mouseenter)="mousen(ca.name)" [class.highlight]="highlightCa() === ca.name" class="material">
                                <div class="cols nrs">
                                    @for (status of statuses(); track status) {
                                        <div class="status-{{status.id}}">&nbsp;
                                            {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : status.id : ca.id)?.total  | number :'1.0-0'}}
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (showInspectionsFor() === ca) {
                                @for (inspection of ca.inspections; track inspection) {
                                    <div (mouseenter)="mousen(inspection.name)" [class.highlight]="highlightCa() === inspection.id" class="material">
                                        <div class="cols nrs">
                                            @for (status of statuses(); track status) {
                                                <div class="status-{{status.id}}">&nbsp;
                                                    {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : status.id : ca.id : inspection.id)?.total  | number :'1.0-0'}}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    }
                    <div (mouseenter)="mousen('total')" [class.highlight]="highlightCa() === 'total'" class="material">
                        <div class="cols nrs">
                            @for (status of statuses(); track status) {
                                <div class="status-{{status.id}}">
                                    {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : status.id)?.total  | number :'1.0-0'}}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="type">
                <div class="sticky-top">
                    <div class="name">&nbsp;</div>
                    <div class="cols">
                        <div class="material">
                            <div class="name">
                                <div class="innername">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="cols">
                                <div class="partname whiteborder">&nbsp;</div>
                            </div>
                            <div class="cols header">
                                <div class="status">
                                    <div class="text">Extra kosten</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                @for (ca of customerAreas(); track ca) {
                    <div [class.show-inspections]="showInspectionsFor() === ca" class="customer-area">
                        <div (mouseenter)="mousen(ca.name)" [class.highlight]="highlightCa() === ca.name" class="material">
                            <div class="cols">
                                <div class="part">
                                    <div class="cols nrs extra">
                                        <div>
                                            &nbsp;{{(extraCosts() | totalPriceExtraCosts : pushpinParts() : extraCostsPrices() : ca.id) | number :'1.0-0'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (showInspectionsFor() === ca) {
                            @for (inspection of ca.inspections; track inspection) {
                                <div (mouseenter)="mousen(inspection.id)" [class.highlight]="highlightCa() === inspection.id" class="material">
                                    <div class="cols">
                                        <div class="part">
                                            <div class="cols nrs extra">
                                                <div>
                                                    &nbsp;{{(extraCosts() | totalPriceExtraCosts : pushpinParts() : extraCostsPrices() : ca.id : inspection.id) | number :'1.0-0'}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        }
                    </div>
                }
                <div (mouseenter)="mousen('total')" [class.highlight]="highlightCa() === 'total'" class="cols">
                    <div class="material">
                        <div class="cols">
                            <div class="part">
                                <div class="cols nrs">
                                    <div>
                                        {{(extraCosts() | totalPriceExtraCosts : pushpinParts() : extraCostsPrices()) | number :'1.0-0'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (showMaterialSpecific()) {
                @for (type of types(); track type) {
                    <div class="type">
                        <div class="sticky-top">
                            <div [style.background-color]="type.color" class="name">{{type.name}}</div>
                            <div class="cols">
                                @for (material of materials(); track material) {
                                    <div class="material">
                                        <div [style.background-color]="material.color" class="name">
                                            <div class="innername">
                                                {{material.name}}
                                            </div>
                                        </div>
                                        <div class="cols">
                                            @if (showCount()) {
                                                <div class="partname">Aantal punaises</div>
                                            }
                                            @if (showSurface()) {
                                                <div class="partname">
                                                    {{type.name === 'Figuratie' ? 'Oppervlakte' : 'Lengte'}}
                                                </div>
                                            }
                                            @if (showPrice()) {
                                                <div class="partname revenue">Omzet</div>
                                            }
                                        </div>
                                        <div class="cols header">
                                            @if (showCount()) {
                                                <div class="status freefor">
                                                    <div class="text">Vrij voor uitvoering</div>
                                                </div>
                                                <div class="status executed">
                                                    <div class="text">Uitgevoerd</div>
                                                </div>
                                                <div class="status">
                                                    <div class="text">Percentage</div>
                                                </div>
                                            }
                                            @if (showSurface()) {
                                                <div class="status freefor">
                                                    <div class="text">Vrij voor uitvoering</div>
                                                </div>
                                                <div class="status executed">
                                                    <div class="text">Uitgevoerd</div>
                                                </div>
                                                <div class="status">
                                                    <div class="text">Percentage</div>
                                                </div>
                                            }
                                            @if (showPrice()) {
                                                <div class="status freefor revenue">
                                                    <div class="text">Vrij voor uitvoering</div>
                                                </div>
                                                <div class="status executed revenue">
                                                    <div class="text">Uitgevoerd</div>
                                                </div>
                                                <div class="status revenue">
                                                    <div class="text">Percentage</div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        @for (ca of customerAreas(); track ca) {
                            <div [class.show-inspections]="showInspectionsFor() === ca" class="customer-area per-material">
                                <div (mouseenter)="mousen(ca.name)" [class.highlight]="highlightCa() === ca.name" class="cols">
                                    @for (material of materials(); track material) {
                                        <div class="material">
                                            <div class="cols">
                                                <div class="part">
                                                    <div class="cols nrs">
                                                        @if (showCount()) {
                                                            <div class="freefor">
                                                                {{(pushpinParts() | totalCountPushpinParts : StatusId.VrijVoorUitvoering : ca.id : null : material.id : type.priceType) | number :'1.0-0'}}
                                                            </div>
                                                            <div class="executed">
                                                                {{(pushpinParts() | totalCountPushpinParts : StatusId.Uitgevoerd : ca.id : null : material.id : type.priceType) | number :'1.0-0'}}
                                                            </div>
                                                            <div class="other">
                                                                {{(pushpinParts() | percentCount : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : ca.id : null : material.id : type.priceType)}}
                                                            </div>
                                                        }
                                                        @if (showSurface()) {
                                                            <div class="freefor">
                                                                {{(pushpinParts() | totalSurfacePushpinParts : StatusId.VrijVoorUitvoering : ca.id : null : material.id : type.priceType) | number :'1.0-0'}}
                                                            </div>
                                                            <div class="executed">
                                                                {{(pushpinParts() | totalSurfacePushpinParts : StatusId.Uitgevoerd : ca.id : null : material.id : type.priceType) | number :'1.0-0'}}
                                                            </div>
                                                            <div class="other">
                                                                {{(pushpinParts() | percentSurface : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : ca.id : null : material.id : type.priceType)}}
                                                            </div>
                                                        }
                                                        @if (showPrice()) {
                                                            <div class="freefor revenue">
                                                                {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : StatusId.VrijVoorUitvoering : ca.id : null : material.id : type.priceType)?.total  | number :'1.0-0'}}
                                                            </div>
                                                            <div class="executed revenue">
                                                                {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : StatusId.Uitgevoerd : ca.id : null : material.id : type.priceType)?.total  | number :'1.0-0'}}
                                                            </div>
                                                            <div class="other revenue">
                                                                {{(pushpinParts() | percentPrice : materialPrices() : decorationPrices() : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : ca.id : null : material.id : type.priceType)}}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                @if (showInspectionsFor() === ca) {
                                    @for (inspection of ca.inspections; track inspection) {
                                        <div (mouseenter)="mousen(inspection.id)" [class.highlight]="highlightCa() === inspection.id" class="cols">
                                            @for (material of materials(); track material) {
                                                <div class="material">
                                                    <div class="cols">
                                                        <div class="part">
                                                            <div class="cols nrs">
                                                                @if (showCount()) {
                                                                    <div class="freefor">
                                                                        {{(pushpinParts() | totalCountPushpinParts : StatusId.VrijVoorUitvoering : ca.id : inspection.id : material.id : type.priceType) | number :'1.0-0'}}
                                                                    </div>
                                                                    <div class="executed">
                                                                        {{(pushpinParts() | totalCountPushpinParts : StatusId.Uitgevoerd : ca.id : inspection.id : material.id : type.priceType) | number :'1.0-0'}}
                                                                    </div>
                                                                    <div class="other">
                                                                        {{(pushpinParts() | percentCount : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : ca.id : inspection.id : material.id : type.priceType)}}
                                                                    </div>
                                                                }
                                                                @if (showSurface()) {
                                                                    <div class="freefor">
                                                                        {{(pushpinParts() | totalSurfacePushpinParts : StatusId.VrijVoorUitvoering : ca.id : inspection.id : material.id : type.priceType) | number :'1.0-0'}}
                                                                    </div>
                                                                    <div class="executed">
                                                                        {{(pushpinParts() | totalSurfacePushpinParts : StatusId.Uitgevoerd : ca.id : inspection.id : material.id : type.priceType) | number :'1.0-0'}}
                                                                    </div>
                                                                    <div class="other">
                                                                        {{(pushpinParts() | percentSurface : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : ca.id : inspection.id : material.id : type.priceType)}}
                                                                    </div>
                                                                }
                                                                @if (showPrice()) {
                                                                    <div class="freefor revenue">
                                                                        {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : StatusId.VrijVoorUitvoering : ca.id : inspection.id : material.id : type.priceType)?.total  | number :'1.0-0'}}
                                                                    </div>
                                                                    <div class="executed revenue">
                                                                        {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : StatusId.Uitgevoerd : ca.id : inspection.id : material.id : type.priceType)?.total  | number :'1.0-0'}}
                                                                    </div>
                                                                    <div class="other revenue">
                                                                        {{(pushpinParts() | percentPrice : materialPrices() : decorationPrices() : StatusId.VrijVoorUitvoering : StatusId.Uitgevoerd : ca.id : inspection.id : material.id : type.priceType)}}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        }
                        <div (mouseenter)="mousen('total')" [class.highlight]="highlightCa() === 'total'" class="cols">
                            @for (material of materials(); track material) {
                                @if (material) {
                                    <div class="material">
                                        <div class="cols">
                                            <div class="part">
                                                <div class="cols nrs">
                                                    @if (showCount()) {
                                                        <div class="freefor">
                                                            {{(pushpinParts() | totalCountPushpinParts : StatusId.VrijVoorUitvoering : null : null : material.id : type.priceType) | number :'1.0-0'}}
                                                        </div>
                                                        <div class="executed">
                                                            {{(pushpinParts() | totalCountPushpinParts : StatusId.Uitgevoerd : null : null : material.id : type.priceType) | number :'1.0-0'}}
                                                        </div>
                                                        <div class="other">
                                                            {{(pushpinParts() | percentCount : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : null : null : material.id : type.priceType)}}
                                                        </div>
                                                    }
                                                    @if (showSurface()) {
                                                        <div class="freefor">
                                                            {{(pushpinParts() | totalSurfacePushpinParts : StatusId.VrijVoorUitvoering : null : null : material.id : type.priceType) | number :'1.0-0'}}
                                                        </div>
                                                        <div class="executed">
                                                            {{(pushpinParts() | totalSurfacePushpinParts : StatusId.Uitgevoerd : null : null : material.id : type.priceType) | number :'1.0-0'}}
                                                        </div>
                                                        <div class="other">
                                                            {{(pushpinParts() | percentSurface : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : null : null : material.id : type.priceType)}}
                                                        </div>
                                                    }
                                                    @if (showPrice()) {
                                                        <div class="freefor revenue">
                                                            {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : StatusId.VrijVoorUitvoering : null : null : material.id : type.priceType)?.total  | number :'1.0-0'}}
                                                        </div>
                                                        <div class="executed revenue">
                                                            {{(pushpinParts() | totalPricePushpinParts : materialPrices() : decorationPrices() : StatusId.Uitgevoerd : null : null : material.id : type.priceType)?.total  | number :'1.0-0'}}
                                                        </div>
                                                        <div class="other revenue">
                                                            {{(pushpinParts() | percentPrice : materialPrices() : decorationPrices() : StatusId.VrijVoorUitvoering :StatusId.Uitgevoerd : null : null : material.id : type.priceType)}}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                }
            }
        </div>
    }
</div>
